import { useRecoilState } from "recoil";
import topButton from "../../assets/top-button.png";
import navigationNameAtom from "../../stores/navigationNameAtom";

import "./scrollTop.css";

const ScrollTop = () => {
  // eslint-disable-next-line no-unused-vars
  const [navigationName, setNavigationName] =
    useRecoilState(navigationNameAtom);
  window.addEventListener("scroll", (e) => {
    var el = document.getElementById("jsScroll");
    if (window.scrollY > 400) {
      el.classList.add("visible");
    } else if (window.scrollY < 400) {
      el.classList.remove("visible");
    }
  });

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setNavigationName("Accueil");
  }
  return (
    <div>
      <div id="jsScroll" className="scroll" onClick={scrollToTop}>
        <img loading="lazy" className="fa fa-angle-up" src={topButton} alt="" />
      </div>
    </div>
  );
};

export default ScrollTop;
